module.exports = __webpack_public_path__ + "static/Sopie-28d1ff158fa7016c808630530559dff7.png";